module.exports = __webpack_public_path__ + "static/cr-below-average-8a31a868d443ae3ab59cb4951b016561.png";